module.exports = __webpack_public_path__ + "assets/media/swallow_practice_new.9d888f71.mp4";